module.exports = __webpack_public_path__ + "img/cd14cff.svg";